/** @file JSON Schema of one command's input (zod → JSON Schema, input side) for describe_command. */
import { lookupCommand } from '@pose2d/commands/lookupCommand';
import { throwError } from '@pose2d/format/throwError';
import { z } from 'zod';

/** Fields with defaults are optional in the schema (`io: 'input'`); refinements without a JSON form become `{}`. */
export function describeCommand(name: string): { name: string; description: string; input: Record<string, unknown> } {
  const def = lookupCommand(name) ?? throwError('NOT_FOUND', { kind: 'command', ref: name }, { path: 'name', hint: 'list_commands gives every command name' });
  return { name: def.name, description: def.description, input: z.toJSONSchema(def.input, { io: 'input', unrepresentable: 'any' }) };
}
